import { styled } from '@mui/material/styles'
import { Autocomplete, autocompleteClasses, Box, IconButton, List, ListItemButton, Typography } from '@mui/material'
import { AppButton, Content } from '@/components/ui'
import Grid from '@mui/material/Grid2'

export const Form = styled('form')`
  height: 100%;
  position: relative;
`

export const Title = styled(Typography)`
  color: ${({ theme }) => theme.custom.colors.common.red};

  ${({ theme }) => theme.breakpoints.down('xs')} {
    font-size: 16px;
  }
`

export const Subtitle = styled(Typography)`
  color: ${({ theme }) => theme.custom.colors.common.black};
  margin-top: ${({ theme }) => theme.spacing(1)};
`

export const OrganizationIdWrapper = styled(Box)`
  margin-top: ${({ theme }) => theme.spacing(3)};
`

export const FindButton = styled(IconButton)`
  color: ${({ theme }) => theme.custom.colors.common.red};
  margin-top: ${({ theme }) => theme.spacing(1)};
  border-radius: 4px;
`

export const Button = styled(AppButton)`
  width: 100px;

  ${({ theme }) => theme.breakpoints.down('xs')} {
    width: 100%;
  }
`

export const ShopButton = styled(Button)`
  background-color: ${({ theme }) => theme.custom.colors.common.red};

  &:disabled {
    background-color: ${({ theme }) => theme.custom.colors.common.grey1};
    color: ${({ theme }) => theme.palette.common.white};
  }
`

export const SelectedOrganization = styled(Box)`
  margin-top: ${({ theme }) => theme.spacing(1)};
  padding: ${({ theme }) => theme.spacing(1)} ${({ theme }) => theme.spacing(2)};
  background-color: ${({ theme }) => theme.custom.colors.common.grey};
`

export const OrganizationId = styled(Typography)`
  color: ${({ theme }) => theme.custom.colors.common.red};
`

export const OrganizationAddress = styled(Typography)`
  color: ${({ theme }) => theme.custom.colors.common.black};
  margin-top: ${({ theme }) => theme.spacing(1)};
`

export const OrganizationName = styled(Typography)`
  color: ${({ theme }) => theme.custom.colors.common.red};
`

export const InputGrid = styled(Grid)`
  margin-top: 0;
  max-height: calc(100% - 50px);
  flex-direction: column;
  flex-wrap: nowrap;
  padding: ${({ theme }) => theme.spacing(2)} 0;
`

export const OrganizationGrid = styled(Grid)`
  height: 100%;
  overflow-y: auto;
`

export const OrganizationStateInput = styled(Autocomplete)({
  [`.${autocompleteClasses.inputRoot}`]: {
    height: 46,
    padding: '0 65px 0 0',
    [`.${autocompleteClasses.input}:first-child`]: {
      paddingLeft: 13,
    },
  },
}) as typeof Autocomplete

export const OrganizationList = styled(List)`
  padding: 0 0 20px 0;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding-bottom: 50px;
  }
`

export const OrganizationItem = styled(ListItemButton)`
  padding: ${({ theme }) => theme.spacing(2)} 0;
`

export const ContentWrapper = styled(Content, {
  shouldForwardProp: (prop) => prop !== 'isMobileLandscape',
})<{ isMobileLandscape: boolean }>`
  ${({ theme }) => theme.breakpoints.down('md')} {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: ${({ isMobileLandscape }) => (isMobileLandscape ? 'unset' : '100%')};
    min-height: 0;
    overflow: hidden;
    padding: 15px;
  }
`

export const ParticipantList = styled(List)`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  margin-top: ${({ theme }) => theme.spacing(2)};
  margin-bottom: ${({ theme }) => theme.spacing(4)};
  overflow-x: hidden;
  gap: 24px;
  width: 100%;

  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 100%;
    gap: 12px;
  }
`

export const SupporterShopButton = styled(AppButton)`
  width: 142px;
  background-color: ${({ theme }) => theme.custom.colors.common.red};
  margin-top: ${({ theme }) => theme.spacing(4)};

  ${({ theme }) => theme.breakpoints.down('sm')} {
    width: 100%;
    height: 42px;
    margin-top: ${({ theme }) => theme.spacing(2)};
  }
` as typeof AppButton

export const HeaderWrapper = styled(Box)`
  ${({ theme }) => theme.breakpoints.down('sm')} {
    display: flex;
    flex-direction: column;
    text-align: left;
  }
`

export const OrganizationDetails = styled(Typography)`
  font-size: 14px;
`

export const OrganizationMainData = styled(Box)`
  gap: 5px;
  margin-top: ${({ theme }) => theme.spacing(1)};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  ${({ theme }) => theme.breakpoints.down('sm')} {
    gap: 10px;
    flex-direction: column-reverse;
  }
`
export const OrganizationMainDataLeftPart = styled(Box)``

export const DefaultParticipantCard = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
`
export const DefaultParticipantCardName = styled(Typography)`
  color: ${({ theme }) => theme.custom.colors.common.black};
  text-decoration: underline;
  margin-top: 1px;
  text-align: center;
  font-size: 16px;
`
